import {mapLTLLogo} from "../../Utils/Helper";

const STATUS_DESCRIPTIONS = {
    "Label Created": "Shipping label created and ready for pickup",
    Dispatched: "Shipment dispatched from origin",
    "Picked Up": "Package picked up from shipper",
    "Arrived at Terminal": "Freight arrived at terminal facility",
    "Departed Terminal": "Freight departed terminal facility",
    "Scanned On Dock": "Freight scanned on warehouse dock",
    "Loaded On Trailer": "Freight loaded onto outbound trailer",
    "Freight Unloaded": "Freight unloaded at terminal",
    "In Transit": "Shipment is in transit to destination",
    "Arrived at Delivery Facility": "Freight arrived at local delivery facility",
    "Out for Delivery": "Package is on the delivery vehicle",
    Delivered: "Package delivered to recipient",
    Exception: "Delivery exception, action needed",
    "Customs Review": "Shipment held for customs review",
    "Arrived at Border Crossing": "Freight arrived at border crossing",
};

const buildMockEvent = (status, time, city, province, done, description, warning) => ({
    status,
    description: description || STATUS_DESCRIPTIONS[status] || status,
    time,
    city,
    province,
    done,
    warning,
});

export const MOCK_TRACKING_DATA = {
    UU128900445CA: {
        trackingNumber: "UU128900445CA",
        bolNumber: "BOL-458213",
        proNumber: "91045822",
        status: "In Transit",
        carrier: "Vitran",
        carrierLogo: mapLTLLogo("vitran"),
        eta: "Jun 26, 2026",
        lastUpdated: "Today, 10:42 AM",
        origin: "Vancouver, BC",
        destination: "Richmond, BC",
        service: "Standard Parcel",
        milestones: [
            {label: "Label Created", date: "Jun 24", done: true},
            {label: "Dispatched", date: "Jun 24", done: true},
            {label: "Picked Up", date: "Jun 24", done: true},
            {label: "In Transit", date: "Jun 25", done: false},
            {label: "Out for Delivery", date: null, done: false},
            {label: "Delivered", date: null, done: false},
        ],
        events: [
            buildMockEvent("Arrived at Delivery Facility", "2026-06-25 19:40", "Richmond", "BC", true),
            buildMockEvent("In Transit", "2026-06-25 07:20", "Burnaby", "BC", true),
            buildMockEvent("Departed Terminal", "2026-06-25 02:10", "Vancouver Terminal", "BC", true),
            buildMockEvent("Arrived at Terminal", "2026-06-24 20:30", "Vancouver Terminal", "BC", true),
            buildMockEvent("Picked Up", "2026-06-24 14:35", "Vancouver", "BC", true),
            buildMockEvent("Label Created", "2026-06-24 08:12", "Vancouver", "BC", true),
        ],
    },
    UU998200761CA: {
        trackingNumber: "UU998200761CA",
        bolNumber: "BOL-772041",
        proNumber: "91098320",
        status: "Delivered",
        carrier: "Vitran",
        carrierLogo: mapLTLLogo("vitran"),
        eta: "Delivered",
        lastUpdated: "Jun 23, 2026 4:18 PM",
        origin: "Richmond, BC",
        destination: "Surrey, BC",
        service: "Priority Parcel",
        milestones: [
            {label: "Label Created", date: "Jun 21", done: true},
            {label: "Dispatched", date: "Jun 21", done: true},
            {label: "Picked Up", date: "Jun 21", done: true},
            {label: "In Transit", date: "Jun 22", done: true},
            {label: "Out for Delivery", date: "Jun 23", done: true},
            {label: "Delivered", date: "Jun 23", done: true},
        ],
        events: [
            buildMockEvent("Delivered", "2026-06-23 16:18", "Surrey", "BC", true),
            buildMockEvent("Out for Delivery", "2026-06-23 09:05", "Surrey", "BC", true),
            buildMockEvent("Arrived at Delivery Facility", "2026-06-22 22:40", "Surrey", "BC", true),
            buildMockEvent("In Transit", "2026-06-22 06:40", "Delta", "BC", true),
            buildMockEvent("Departed Terminal", "2026-06-21 23:15", "Richmond Terminal", "BC", true),
            buildMockEvent("Picked Up", "2026-06-21 13:52", "Richmond", "BC", true),
            buildMockEvent("Label Created", "2026-06-21 09:10", "Richmond", "BC", true),
        ],
    },
    UU554320118CA: {
        trackingNumber: "UU554320118CA",
        bolNumber: "BOL-390156",
        proNumber: "91076154",
        status: "Exception",
        carrier: "Vitran",
        carrierLogo: mapLTLLogo("vitran"),
        eta: "Action needed",
        lastUpdated: "Today, 9:05 AM",
        origin: "Richmond, BC",
        destination: "Seattle, WA",
        service: "Cross-border Parcel",
        milestones: [
            {label: "Label Created", date: "Jun 23", done: true},
            {label: "Dispatched", date: "Jun 23", done: true},
            {label: "Picked Up", date: "Jun 23", done: true},
            {label: "In Transit", date: "Jun 24", done: true},
            {label: "Out for Delivery", date: null, done: false},
            {label: "Delivered", date: null, done: false},
        ],
        events: [
            buildMockEvent("On Hold", "2026-06-24 09:20", "Pacific Highway", "BC", true, "Shipment is on hold pending customs clearance", true),
            buildMockEvent("Exception", "2026-06-24 09:05", "Pacific Highway", "BC", true),
            buildMockEvent("Customs Review", "2026-06-24 08:46", "Pacific Highway", "BC", true),
            buildMockEvent("Arrived at Border Crossing", "2026-06-24 06:20", "Pacific Highway", "BC", true),
            buildMockEvent("In Transit", "2026-06-23 22:10", "Bellingham", "WA", true),
            buildMockEvent("Departed Terminal", "2026-06-23 19:45", "Richmond Terminal", "BC", true),
            buildMockEvent("Picked Up", "2026-06-23 17:32", "Richmond", "BC", true),
            buildMockEvent("Label Created", "2026-06-23 12:08", "Richmond", "BC", true),
        ],
    },
};

export const buildGeneratedMockResult = (trackingNumber) => ({
    trackingNumber,
    bolNumber: "BOL-100234",
    proNumber: "91011223",
    status: "In Transit",
    carrier: "Vitran",
    carrierLogo: mapLTLLogo("vitran"),
    eta: "Jun 27, 2026",
    lastUpdated: "Today, 11:20 AM",
    origin: "Richmond, BC",
    destination: "Vancouver, BC",
    service: "Ground Service",
    milestones: [
        {label: "Label Created", date: "Jun 24", done: true},
        {label: "Dispatched", date: "Jun 24", done: true},
        {label: "Picked Up", date: "Jun 24", done: true},
        {label: "In Transit", date: "Jun 25", done: false},
        {label: "Out for Delivery", date: null, done: false},
        {label: "Delivered", date: null, done: false},
    ],
    events: [
        buildMockEvent("On Hold", "2026-06-26 07:30", "Vancouver", "BC", true, "Shipment is on hold pending consignee contact", true),
        buildMockEvent("Arrived at Delivery Facility", "2026-06-26 07:15", "Vancouver", "BC", true),
        buildMockEvent("Scanned On Dock", "2026-06-25 22:30", "Burnaby Terminal", "BC", true),
        buildMockEvent("Loaded On Trailer", "2026-06-25 11:20", "Burnaby Terminal", "BC", true),
        buildMockEvent("Departed Terminal", "2026-06-25 06:40", "Richmond Terminal", "BC", true),
        buildMockEvent("Picked Up", "2026-06-24 15:10", "Richmond", "BC", true),
        buildMockEvent("Label Created", "2026-06-24 08:30", "Richmond", "BC", true),
    ],
});

export const buildNoTrackingPreviewResult = (trackingNumber = "0") => ({
    trackingNumber,
    bolNumber: "Pending",
    proNumber: "Pending",
    status: "No Tracking Yet",
    carrier: "N/A",
    eta: "Tracking pending",
    lastUpdated: "No carrier scan yet",
    origin: "Origin pending",
    destination: "Destination pending",
    service: "LTL Freight",
    milestones: [
        {label: "Label Created", date: null, done: false},
        {label: "Dispatched", date: null, done: false},
        {label: "Picked Up", date: null, done: false},
        {label: "In Transit", date: null, done: false},
        {label: "Out for Delivery", date: null, done: false},
        {label: "Delivered", date: null, done: false},
    ],
    events: [{
        status: "No tracking updates yet",
        description: "No tracking updates yet",
        time: "Pending",
        city: "Waiting for carrier scan",
        province: "",
        done: false,
    }],
});

export const PACKAGE_SHIPPING_STATUS_LABEL_CREATED = "Label Created";
export const PACKAGE_SHIPPING_STATUS_DISPATCHED = "Dispatched";
export const PACKAGE_SHIPPING_STATUS_PICKED_UP = "Picked up";
export const PACKAGE_SHIPPING_STATUS_IN_TRANSIT = "In Transit";
export const PACKAGE_SHIPPING_STATUS_OUT_OF_DELIVERY = "Out of Delivery";
export const PACKAGE_SHIPPING_STATUS_ETA = "ETA";
export const PACKAGE_SHIPPING_STATUS_DELIVERED = "Delivered";
export const PACKAGE_SHIPPING_STATUS_CANCELLED = "Cancelled";

export const PACKAGE_SHIPPING_TRACKING_STATUS_LABEL_CREATED = 0;
export const PACKAGE_SHIPPING_TRACKING_STATUS_DISPATCHED = 4;
export const PACKAGE_SHIPPING_TRACKING_STATUS_PICKED_UP = 10;
export const PACKAGE_SHIPPING_TRACKING_STATUS_IN_TRANSIT = 1;
export const PACKAGE_SHIPPING_TRACKING_STATUS_OUT_OF_DELIVERY = 20;
export const PACKAGE_SHIPPING_TRACKING_STATUS_ETA = 3;
export const PACKAGE_SHIPPING_TRACKING_STATUS_DELIVERED = 2;
export const PACKAGE_SHIPPING_TRACKING_STATUS_FAILED = -1;
export const PACKAGE_SHIPPING_TRACKING_STATUS_CANCELLED = -2;

export const trackingStatusList = [
    {code: PACKAGE_SHIPPING_TRACKING_STATUS_LABEL_CREATED, name: PACKAGE_SHIPPING_STATUS_LABEL_CREATED},
    {code: PACKAGE_SHIPPING_TRACKING_STATUS_DISPATCHED, name: PACKAGE_SHIPPING_STATUS_DISPATCHED},
    {code: PACKAGE_SHIPPING_TRACKING_STATUS_PICKED_UP, name: PACKAGE_SHIPPING_STATUS_PICKED_UP},
    {code: PACKAGE_SHIPPING_TRACKING_STATUS_IN_TRANSIT, name: PACKAGE_SHIPPING_STATUS_IN_TRANSIT},
    {code: PACKAGE_SHIPPING_TRACKING_STATUS_DELIVERED, name: PACKAGE_SHIPPING_STATUS_DELIVERED},
    {code: PACKAGE_SHIPPING_TRACKING_STATUS_ETA, name: PACKAGE_SHIPPING_STATUS_ETA},
    {code: PACKAGE_SHIPPING_TRACKING_STATUS_CANCELLED, name: PACKAGE_SHIPPING_STATUS_CANCELLED},
]

export const getShippingStatusNameByStatusId = ({statusId}) => {
    switch (+statusId) {
        case PACKAGE_SHIPPING_TRACKING_STATUS_LABEL_CREATED:
            return PACKAGE_SHIPPING_STATUS_LABEL_CREATED;
        case PACKAGE_SHIPPING_TRACKING_STATUS_DISPATCHED:
            return PACKAGE_SHIPPING_STATUS_DISPATCHED;
        case PACKAGE_SHIPPING_TRACKING_STATUS_PICKED_UP:
            return PACKAGE_SHIPPING_STATUS_PICKED_UP;
        case PACKAGE_SHIPPING_TRACKING_STATUS_IN_TRANSIT:
            return PACKAGE_SHIPPING_STATUS_IN_TRANSIT;
        case PACKAGE_SHIPPING_TRACKING_STATUS_OUT_OF_DELIVERY:
            return PACKAGE_SHIPPING_STATUS_OUT_OF_DELIVERY;
        case PACKAGE_SHIPPING_TRACKING_STATUS_ETA:
            return PACKAGE_SHIPPING_STATUS_ETA;
        case PACKAGE_SHIPPING_TRACKING_STATUS_DELIVERED:
            return PACKAGE_SHIPPING_STATUS_DELIVERED;
        case PACKAGE_SHIPPING_TRACKING_STATUS_CANCELLED:
            return PACKAGE_SHIPPING_STATUS_CANCELLED;
        default:
            return PACKAGE_SHIPPING_TRACKING_STATUS_LABEL_CREATED;
    }
};

export const mapApiDataToResult = (apiData) => {
    const events = (apiData.events || []).map((event, index) => ({
        status: event.trackingEvent || event.status || event.description || "",
        description: event.description || event.trackingEvent || event.status || "",
        time: event.date || "",
        address: event.address?.address || "",
        city: event.address?.city || "",
        province: event.address?.province || "",
        country: event.address?.country || "",
        done: true,
        warning: false,
    }));

    return {
        trackingNumber: apiData.trackingNumber || "",
        bolNumber: apiData.bolNumber || "N/A",
        proNumber: apiData.proNumber || "N/A",
        status: apiData.status || "In Transit",
        carrier: apiData.accountBase || apiData.carrier || "N/A",
        carrierLogo: apiData.iconURI || apiData.carrierLogo || null,
        eta: apiData.ETA || apiData.eta || "Pending",
        lastUpdated: apiData.lastUpdated || apiData.deliveryDate || "",
        origin: apiData.origin || "Origin pending",
        destination: apiData.destination || "Destination pending",
        service: apiData.service || "",
        milestones: apiData.milestones || [],
        shipmentTypeId: apiData.shipmentTypeId,
        email: apiData.email || [],
        phone: apiData.phone || [],
        events,
    };
};

export const dummyData = {
    "accountBase": "Fedex",
    "iconURI": "uucargo-resource/image/icon/FedExLogo.png",
    "backendOrderId": 4991,
    "shipmentTypeId": 5,
    "trackingNumber": "874337347532",
    "proNumber": "",
    "bolNumber": "",
    "status": "Delivered",
    "statusCode": 2,
    "originalResponse": "From DB",
    "deliveryDate": "2026-06-05 12:29",
    "ETA": "2026-06-05 12:29",
    "origin": "Vancouver, BC",
    "destination": "Toronto, ON",
    "lastUpdated": "",
    "milestones": [
        {"label": "Label Created", "date": "2026-06-01", "done": true},
        {"label": "Dispatched", "date": "2026-06-02", "done": true},
        {"label": "Picked Up", "date": "2026-06-03", "done": true},
        {"label": "In Transit", "date": "2026-06-04", "done": true},
        {"label": "Out for Delivery", "date": "2026-06-05", "done": true},
        {"label": "Delivered", "date": "2026-06-05", "done": true},
    ],
    "events": [
        {
            "description": "Shipment Delivered",
            "address": {"address": "", "city": "Toronto", "province": "ON", "country": "Canada"},
            "date": "2026-06-05 12:29",
            "statusCode": "2",
            "status": "Delivered",
            "trackingEvent": "Shipment Delivered",
            "isCrossborder": 0
        },
        {
            "description": "Package out for delivery",
            "address": {"address": "", "city": "Toronto", "province": "ON", "country": "Canada"},
            "date": "2026-06-05 08:15",
            "statusCode": "20",
            "status": "Out for Delivery",
            "trackingEvent": "Out for Delivery",
            "isCrossborder": 0
        },
        {
            "description": "Arrived at delivery facility",
            "address": {"address": "", "city": "Toronto", "province": "ON", "country": "Canada"},
            "date": "2026-06-04 22:30",
            "statusCode": "1",
            "status": "In Transit",
            "trackingEvent": "Arrived at Delivery Facility",
            "isCrossborder": 0
        },
        {
            "description": "In transit",
            "address": {"address": "", "city": "Winnipeg", "province": "MB", "country": "Canada"},
            "date": "2026-06-04 14:20",
            "statusCode": "1",
            "status": "In Transit",
            "trackingEvent": "In Transit",
            "isCrossborder": 0
        },
        {
            "description": "Departed from facility",
            "address": {"address": "", "city": "Vancouver", "province": "BC", "country": "Canada"},
            "date": "2026-06-03 19:45",
            "statusCode": "10",
            "status": "Picked Up",
            "trackingEvent": "Departed from Facility",
            "isCrossborder": 0
        },
        {
            "description": "Shipment dispatched from origin",
            "address": {"address": "", "city": "Vancouver", "province": "BC", "country": "Canada"},
            "date": "2026-06-02 14:30",
            "statusCode": "4",
            "status": "Dispatched",
            "trackingEvent": "",
            "isCrossborder": 0
        },
        {
            "description": "Label created",
            "address": {"address": "", "city": "Vancouver", "province": "BC", "country": "Canada"},
            "date": "2026-06-01 10:00",
            "statusCode": "0",
            "status": "Label Created",
            "trackingEvent": "Label Created",
            "isCrossborder": 0
        },
    ]
}
